var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResumeicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000006846"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.5 21C16.299 21 21 16.299 21 10.5C21 4.70101 16.299 0 10.5 0C4.70101 0 0 4.70101 0 10.5C0 16.299 4.70101 21 10.5 21Z",
    fill: "#243B55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.00086 11.0209C8.00086 12.3426 7.99989 13.6633 8.00281 14.985C8.00281 15.1208 8.0135 15.2576 8.03683 15.3913C8.12433 15.8899 8.48598 16.1159 8.9322 15.9418C9.079 15.8848 9.21802 15.7956 9.34732 15.7013C11.037 14.4667 12.7227 13.2269 14.4114 11.9902C14.6972 11.7808 14.9373 11.532 14.9888 11.1516C15.0501 10.6986 14.8547 10.3534 14.5173 10.1025C13.5072 9.35199 12.4923 8.60874 11.4783 7.86341C10.7813 7.35028 10.0862 6.83301 9.38329 6.32818C9.20927 6.20378 9.01484 6.09598 8.81554 6.03067C8.5132 5.93115 8.23029 6.07939 8.11461 6.39452C8.04558 6.58319 8.00767 6.79673 8.00572 6.99887C7.99697 8.33922 8.00086 9.67956 8.00086 11.0209Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResumeicon);
export default __webpack_public_path__ + "static/media/resumeicon.d3df9cdfde970fe8a535b18af39c7140.svg";
export { ForwardRef as ReactComponent };